import React, { useState } from 'react';

import './css/burger.css'
import { Img } from '../img';
import { useNavigate } from 'react-router-dom';



export const BurgerMenu = () => {
  const [open, setOpen] = useState(false);

  const handleToggle = () => {
    setOpen(!open);
  };

  const navigate=useNavigate()

  const navigateHandler=(path:string)=>{
    setOpen(false)  
    navigate(path)

  }


  return (
    <nav className="navbar">
    <div className="burger-icon" onClick={handleToggle}>
      <div className={`line`}></div>
      <div className={`line`}></div>
      <div className={`line`}></div>
    </div>
    <ul className={`navbar-menu ${open ? 'open' : ''}`}>
        <div className='navbar-menu-content p-3'>
            <div className='navbar-menu-headers'>
                <p onClick={()=>navigateHandler('/')} className='navbar-menu-link'>golovna</p>
                <p onClick={()=>navigateHandler('/rules')} className='navbar-menu-link'>rules</p>
            </div>
            <div className='navbar-menu-footer mb-4'>
                <div className='d-flex justify-content-center '>  
                  <div className='mx-2' style={{padding:'20px',background:"#FFB000",borderRadius:'15px'}}>
                      <Img height='27px' width='27px' imgPath='ELEMENTS.png'/>
                  </div>
                  <div className='mx-2' style={{padding:'20px',background:"#FFB000",borderRadius:'15px'}}>
                      <Img height='25px' width='25px' imgPath='Vector.png'/>
                  </div>
                </div>
                <div className='navbar-menu-footer-text py-4'>
                    <p >зареєструйте код через чат-бот у Viber чи Telegram</p>
                </div>
                
            </div>
            
        </div>
       
     
    </ul>
    <style>
        {`  body{
                ${open?`overflow:hidden`:``}
            }
        `}
    </style>
  </nav>
);
};
export default BurgerMenu;